import { istCompactDate } from '../utils/istTime';

/**
 * Documented download filenames (U77). The API is cross-origin and may not
 * expose `Content-Disposition`, so these patterns are the fallback.
 */

/** `{CODE}[-{slug}].{png|svg}` */
export function qrFilename(code, slug, format) {
  const base = String(code || '').toUpperCase();
  return slug ? `${base}-${slug}.${format}` : `${base}.${format}`;
}

/** `qr-labels-{template}-{yyyymmdd}.pdf` (IST date). */
export function printSheetFilename(templateKey, instant = Date.now()) {
  return `qr-labels-${templateKey}-${istCompactDate(instant)}.pdf`;
}

/** `link-hits-{from}-{to}.csv` */
export function hitsCsvFilename(from, to) {
  return `link-hits-${from}-${to}.csv`;
}

/** `link-campaign-summary-{from}-{to}.csv` */
export function campaignSummaryFilename(from, to) {
  return `link-campaign-summary-${from}-${to}.csv`;
}

const FILENAME_STAR = /filename\*\s*=\s*(?:UTF-8|utf-8)''([^;]+)/;
const FILENAME_QUOTED = /filename\s*=\s*"([^"]+)"/;
const FILENAME_BARE = /filename\s*=\s*([^;\s]+)/;

/**
 * The filename from a `Content-Disposition` header, or null when the header
 * is absent or unreadable. Path separators are stripped.
 * @param {string|null|undefined} header
 * @returns {string|null}
 */
export function filenameFromDisposition(header) {
  if (!header || typeof header !== 'string') return null;
  const star = header.match(FILENAME_STAR);
  let name = null;
  if (star) {
    try {
      name = decodeURIComponent(star[1].trim());
    } catch {
      name = null;
    }
  }
  if (!name) {
    const quoted = header.match(FILENAME_QUOTED) || header.match(FILENAME_BARE);
    name = quoted ? quoted[1].trim() : null;
  }
  if (!name) return null;
  const safe = name.replace(/[/\\]/g, '_');
  return safe || null;
}
